import React from 'react';
import { appHasEditor, getAppDashboardData, getAppPages, getAppWidgets, getEditorPlatformComps, getEditorWebComps, isPremiumFromBundle, enableDeleteMLApp, } from '../../../utils/appUtils';
import { EditorType, Origin } from '../../manage-installed-apps-page';
import { composer } from '../../../component-decorators/composer';
import { DeleteDashboardModal } from './delete-dashboard-modal';
import { DeleteWidgetAppModal } from './delete-widget-modal';
import { DeleteHybridAppModal } from './delete-hybrid-modal';
import { DeletePageAppModal } from './delete-page-modal';
import { DeletePremiumModal } from './delete-premium-modal';
import { DeleteEditorModalFromBM } from './delete-editor-modal-from-BM';
import { RenewalType, } from '@wix/ambassador-marketplace/types';
export var DeleteModal = composer()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var app = _a.app, msId = _a.msId, origin = _a.origin, editorUrl = _a.editorUrl, manageAppsStaticsUrl = _a.manageAppsStaticsUrl, deleteApp = _a.deleteApp, closeModal = _a.closeModal, t = _a.t, experiments = _a.experiments, editorType = _a.editorType, baseUrl = _a.baseUrl, authorizationHeader = _a.authorizationHeader, openDeleteModalAppInEditor = _a.openDeleteModalAppInEditor;
    var activePremium = app.isUpgraded && app.premiumAutoRenew !== RenewalType.AUTO_RENEW_OFF;
    var shouldShowPremiumModal = activePremium && !isPremiumFromBundle(app);
    if (shouldShowPremiumModal) {
        return (React.createElement(DeletePremiumModal, { app: app, handleClose: closeModal, t: t, msId: msId }));
    }
    if ((enableDeleteMLApp(app, experiments) && origin === Origin.BIZMGR) ||
        (editorType === EditorType.EDITOR &&
            app.webSolutionBase.id !== '14d84998-ae09-1abf-c6fc-3f3cace5bf19' &&
            appHasEditor(app) &&
            origin === Origin.BIZMGR)) {
        return (React.createElement(DeleteEditorModalFromBM, { app: app, handleClose: closeModal, t: t, openDeleteModalAppInEditor: openDeleteModalAppInEditor, msid: msId }));
    }
    if ((editorType === EditorType.EDITOR &&
        appHasEditor(app) &&
        origin === Origin.EDITOR &&
        app.webSolutionBase.id !== '14d84998-ae09-1abf-c6fc-3f3cace5bf19') ||
        experiments.enabled('specs.marketplace.delete-all-apps') ||
        enableDeleteMLApp(app, experiments)) {
        return (React.createElement(DeleteDashboardModal, { app: app, msId: msId, origin: origin, t: t, handleClose: closeModal, handleDeleteApp: deleteApp, editorType: editorType, baseUrl: baseUrl, authorizationHeader: authorizationHeader, experiments: experiments, showNotification: false }));
    }
    if (!appHasEditor(app) || getEditorWebComps(app).length > 0) {
        return (React.createElement(DeleteDashboardModal, { app: app, msId: msId, origin: origin, t: t, handleClose: closeModal, handleDeleteApp: deleteApp, editorType: editorType, baseUrl: baseUrl, authorizationHeader: authorizationHeader, experiments: experiments, showNotification: true }));
    }
    if (getAppPages(app).length) {
        return (React.createElement(DeletePageAppModal, { app: app, origin: origin, editorUrl: editorUrl, handleClose: closeModal, t: t }));
    }
    if (getAppWidgets(app).length || getEditorPlatformComps(app).length) {
        return (React.createElement(DeleteWidgetAppModal, { app: app, origin: origin, editorUrl: editorUrl, handleClose: closeModal, t: t }));
    }
    if (appHasEditor(app) && getAppDashboardData(app)) {
        return (React.createElement(DeleteHybridAppModal, { app: app, origin: origin, editorUrl: editorUrl, handleClose: closeModal, t: t }));
    }
});
//# sourceMappingURL=delete-modal.js.map